module.exports = __webpack_public_path__ + "static/media/chevron-down-accent.f63f39b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/chevron-down-accent.svg
// module id = 62
// module chunks = 0